export interface MijnAnalyseOptions {
    url: MijnAnalyseOption<string>;
    breadcrumb: MijnAnalyseOption<string>;
    date: MijnAnalyseOption<Date>;
    browser: MijnAnalyseOption<string>;
    session: MijnAnalyseOption<string>;
    customerID: MijnAnalyseOption<string>;
}

export interface MijnAnalyseOption<T> {
    label: string;
    value: T;
}

export interface MijnAnalyseNotification {
    text: string;
    closable: boolean;
    state: MijnAnalyseNotificationState;
}

export enum MijnAnalyseNotificationTypes {
    'arrival' = 'arrival',
    'sent' = 'sent',
    'copy' = 'copy'
}

export enum MijnAnalyseNotificationState {
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning'
}

export interface MijnAnalyseFormFields {
    subject: string;
    body: string;
}

export interface MijnAnalyseSessionInformation {
    sessionID: string;
    customerID: string;
}

export enum MijnAnalyseFormGroupId {
    body = 'body',
    subject = 'subject',
    url = 'url',
    breadcrumb = 'breadcrumb',
    date = 'date',
    browser = ' browser',
    session = 'session',
    customerID = 'customerID',
    technicalInformation = 'technicalinformation'
}
